import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Downloads',
    path: '/commercial/downloads',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
